// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useEffect, useMemo, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {App_context, i_app_context} from 'hola_app_context';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import storage from '/util/storage.js';
// @ts-ignore
import {get, set} from '/util/storage.js';
// @ts-ignore
import {refresh_membership, fetch_rules, get as be_get, rule_set}
    from '../../be.js';
// @ts-ignore
import {period_end_str, get_plan_short_name,
    // @ts-ignore
    period_start_str, is_cancellable, fmt_date}
    from '../../../../../svc/account/pub/membership.js';
import zutil from 'zutil';
import {use_screen} from '../../lib/screen_util';
import Icon_arrow_left from '../../img/hola2023/icons/16/arrow_left.svg';
import {perr, ajax} from 'hola_pub_util';
import {guess_os_and_version} from '../../client_hints_global';
// @ts-ignore
import {get_browser} from 'hola_pub_util';
import {all_plans} from 'hola_opt';
import zcountry from 'zcountry';

import styles from './cp.module.less';

type t_cp_tab = 'profile'|'premium'|'settings'|'apps'|'support'|'menu';
const get_plan_amount = m=>{
    const plan = all_plans.find(el=>el.id==m.plan_id);
    const currency = m._currency||m.currency;
    if (!plan||!plan.currency||!plan.currency[currency.toLowerCase()])
        return m.amount_usd;
    return plan.currency[currency.toLowerCase()].price;
};

const use_premium = (ctx: i_app_context, country_code?: string)=>{
    const [cancelled, set_cancelled] = useState(false);
    const is_plus = ctx.is_plus;
    const {member, user} = ctx;
    const sys = guess_os_and_version();
    const browser = get_browser();
    const cancel = (why, answer)=>{
        etask(function*(){
            try {
                const res = yield fetch('/users/payment/cancel_subscription'
                    +'?no_redirect=1', {method: 'POST', body: {reason: why}});
                if (res!='ok')
                    throw new Error(`cancel_subscription is not ok: ${res}`);
                perr({id: 'www_cancel_subscription', info:
                    {is_mobile: sys.mobile, hola_uid: user.hola_uid}});
                set_cancelled(true);
            } catch(e){
                perr({id: 'www_cancel_subscription_err', info: {
                    is_mobile: sys.mobile,
                    hola_uid: user.hola_uid,
                    error: e,
                }});
            }
            try {
                const info = {
                    survey_id: 'cancel_auto_renewal_survey1',
                    answers: answer ? [answer] : [],
                    text_note: why,
                    user_id: ctx.user?.h_visitor_id,
                    country_code,
                    browser,
                    os: sys.os,
                };
                yield fetch('/surveys', {method: 'POST', body: info});
            } catch(e){ console.log(e); }
        });
    };
    const plan = useMemo(()=>{
        if (!is_plus || !member)
            return null;
        const end = period_end_str(member);
        const name = member.period
            ? get_plan_short_name(member.period)
            : 'Premium';
        const start = period_start_str(member);
        const can_cancel = !member.cancelled && is_cancellable(member);
        if (member.cancelled)
            set_cancelled(true);
        // XXX liviu: _currency is the user selected currency during the buy
        const currency = member._currency||member.currency;
        return {
            name,
            start,
            history: [],
            next: !cancelled && can_cancel && end,
            trial: member?.with_trial,
            amount: get_plan_amount(member),
            currency: zcountry.currency2prefix(currency),
            grace_end: fmt_date(member.end),
            gateway: member?.gateway,
        };
    }, [is_plus, member, cancelled]);
    const header = is_plus && cancelled && member.end || plan?.trial
        ? plan?.trial
        ? 'Hola Premium'
        :`Hola Premium - valid until ${fmt_date(member.end)}`
        : is_plus ? 'Hola Premium' : 'Hola Free';

    return {is_plus, plan, header, cancelled, cancel};
};

const use_settings = (ctx: i_app_context)=>{
    const {user, inited} = ctx;
    const [favorites, set_favorites] = useState([]);
    const [two_step_verif, set_two_step_verif] = useState(!user?.two_step_verif
        || !user.two_step_verif.disabled);
    const [allow_collect, set_allow_collect] = useState(
        !!get('show_favorites'));
    const [unsubscribed, set_unsubscribed] = useState(
        user?.hola_email_unsubscribed===true);
    const show_privacy = user?.providers?.basic != null;
    const email = zutil.get(user, 'emails.0.value');
    const update_favorites = ()=>{
        if (!allow_collect)
            return void set_favorites([]);
        etask(function*(){
            yield fetch_rules();
            const rules = be_get('rules')||{};
            const values = Object.values(rules)
                .filter(({ts})=>ts>Number(get('show_favorites')));
            set_favorites(values);
        });
    };
    useEffect(()=>{
        if (inited)
            update_favorites();
    }, [inited, allow_collect]);
    const remove_favorite = rule=>{
        etask(function*(){
            yield rule_set(Object.assign({md5: 'vpn'}, rule), 0, {del: 1});
            update_favorites();
        });
    };
    const toggle_two_step_verif = ()=>etask(function*(){
        yield fetch('/users/set_two_step_verif', {
            method: 'POST',
            body: {two_step_verif: !!two_step_verif},
        });
        set_two_step_verif(!two_step_verif);
    });
    const toggle_unsubscribed = ()=>etask(function*(){
        yield fetch('/users/set_email_unsubscribe', {
            method: 'POST',
            body: {email, value: !unsubscribed || ''},
        });
        set_unsubscribed(!unsubscribed);
    });
    const toggle_allow_collect = ()=>{
        const value = get('show_favorites');
        const new_value = value ? '' : `${Date.now()}`;
        set('show_favorites', new_value);
        set_allow_collect(!!new_value);
    };
    return {
        user: ctx.user,
        favorites,
        two_step_verif,
        unsubscribed,
        allow_collect,
        show_privacy,
        remove_favorite,
        toggle_two_step_verif,
        toggle_unsubscribed,
        toggle_allow_collect,
    };
};

const logout_me = ()=>{
    return etask(function*(){
        yield ajax({url: '/users/logout/inline', type: 'POST',
            xhrFields: {withCredentials: true}});
        storage.clr_all();
        refresh_membership();
    });
};

const logout_others = ()=>{
    return etask(function*_logout_sessions(){
        try {
            yield ajax({url: '/users/logout/others', type: 'POST',
                xhrFields: {withCredentials: true}});
            return true;
        } catch {
            return false;
        }
    });
};

const use_apps = ()=>{
    const [status, set_status] = useState(null);
    const logout = id=>etask(function*(){
        set_status('loading');
        const res = yield logout_others();
        set_status(res ? 'success' : 'error');
        if (id=='all' && res)
        {
            yield logout_me();
            window.location.reload();
        }
    });
    return {logout, status};
};

export const use_cp = (user_country_code: string, root_path = '/cp')=>{
    const ctx = useContext(App_context);
    const {pathname} = useLocation();
    const {width} = use_screen();
    const history = useHistory();
    const is_mobile = width < 768;
    const section = pathname.replace(root_path, '').replace('/', '');
    const tab = is_mobile && !section ? 'menu' : section || 'profile';
    const premium = use_premium(ctx, user_country_code);
    const settings = use_settings(ctx);
    const apps = use_apps();
    const back_btn = useMemo(()=>{
        return is_mobile ?
          <button className={styles.back}
            onClick={()=>history.push(root_path)}>
            <Icon_arrow_left/>
            <span>Back</span>
          </button> : null;
    }, [is_mobile]);
    const [unverified, set_unverified] = useState(ctx?.user?.emails &&
        !ctx.user.verified);
    const on_verify = ()=>set_unverified(false);
    const user_email = ctx.user?.emails && ctx.user.emails[0]?.value;
    useEffect(()=>{
        if (!ctx.is_client)
            return;
        const on_vis = ()=>{
            if (document.visibilityState!='visible')
                return;
            etask(function*(){
                try {
                    const res = yield ajax({url: '/users/get_user', type: 'GET',
                        xhrFields: {withCredentials: true}});
                    if (!res.user)
                    {
                        yield logout_me();
                        window.location.reload();
                    }
                } catch { return; }
            });
        };
        document.addEventListener('visibilitychange', on_vis);
        return ()=>document.removeEventListener('visibilitychange', on_vis);
    }, [ctx]);
    return {tab: tab as t_cp_tab, premium, settings, apps, is_mobile,
        back_btn, user: ctx.user, inited: ctx.inited, unverified, on_verify,
        user_email};
};

export type t_use_cp = ReturnType<typeof use_cp>;
